import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export function CustomPeriodDialog({ open, onOpenChange, dateFrom, dateTo, onDateFromChange, onDateToChange, onGenerate }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>{t("reports.dialog.customPeriod")}</DialogTitle></DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <p className="text-sm text-muted-foreground">{t("reports.dialog.from")}</p>
              <Input type="date" value={dateFrom} onChange={e => onDateFromChange(e.target.value)} data-testid="date-from" />
            </div>
            <div className="space-y-2">
              <p className="text-sm text-muted-foreground">{t("reports.dialog.to")}</p>
              <Input type="date" value={dateTo} onChange={e => onDateToChange(e.target.value)} data-testid="date-to" />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>{t("reports.dialog.cancel")}</Button>
          <Button onClick={onGenerate} data-testid="create-report-btn">{t("reports.dialog.generate")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
